import { SVGProps } from 'react';

const SvgGift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M231.9 44.4C215.7 16.9 186.1 0 154.2 0H152c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40H48c-26.5 0-48 21.5-48 48v64c0 20.9 13.4 38.7 32 45.3V448c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V285.3c18.6-6.6 32-24.4 32-45.3v-64c0-26.5-21.5-48-48-48h-25.6c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41zM464 176v64H288v-64h176zm-240 0v64H48v-64h176zm0 112v176H96c-8.8 0-16-7.2-16-16V288h144zm64 176V288h144v160c0 8.8-7.2 16-16 16H288zm72-336h-73.3l34.8-59.2c7.6-12.9 21.4-20.8 36.3-20.8h2.2c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-136 0h-72c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8l34.8 59.2H224z" />
  </svg>
);
export default SvgGift;
